module.exports = __webpack_public_path__ + "static/media/Icon_Tutoren_Suchen.bd206380.svg";